// .vitepress/theme/index.js
import DefaultTheme from 'vitepress/theme'
import Layout from './layouts/Layout.vue'
import '@unocss/reset/normalize.css'
import 'virtual:uno.css'
import './styles/index.scss'
import VIcon from './components/global/VIcon.vue'
import { withDataProvider } from './composables/usePageData'
export default {
  extends: DefaultTheme,
  // 使用注入插槽的包装组件覆盖 Layout
  Layout: withDataProvider(Layout),
  enhanceApp({ app }) {
    // 注册自定义全局组件
    app.component('VIcon', VIcon)
  }
}